/**
 * ASKED OF LEVERI, NOT YET A SKILL — the firm's gap log (0037): what people
 * asked Leveri to do that it declined, newest first. What it shows is what to
 * build next; nothing here is computed in the browser.
 */
import { useEffect, useState } from "react";
import { ChatGapsResponse } from "@leveri/contracts";
import { RuledList, Section, SectionHead } from "../file/index.js";
import { call } from "../api.js";

export function GapsSection() {
  const [gaps, setGaps] = useState<ChatGapsResponse["gaps"] | null>(null);
  useEffect(() => { call("GET", "/api/chat/gaps", ChatGapsResponse).then((r) => setGaps(r.gaps)).catch(() => setGaps([])); }, []);
  if (!gaps || gaps.length === 0) return null;
  return (
    <Section>
      <SectionHead>Asked of Leveri, not yet a skill</SectionHead>
      <p className="-mt-2 mb-3 text-[13px] text-stone">What your team asked Leveri to do that it does not do yet. Each one tells us what to build next.</p>
      <div data-testid="gaps"><RuledList>
        {gaps.slice(0, 10).map((g, i) => (
          <div key={`${g.atText}-${i}`} className="py-2.5">
            <p className="text-[15px] text-ink">“{g.instruction}”</p>
            <p className="text-[12px] text-stone">{g.askedBy} · {g.atText}</p>
          </div>
        ))}
      </RuledList></div>
    </Section>
  );
}
